import { render, staticRenderFns } from "./Texts.vue?vue&type=template&id=b3dcd7e4&scoped=true"
import script from "./Texts.vue?vue&type=script&lang=js"
export * from "./Texts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dcd7e4",
  null
  
)

export default component.exports